const initialState = {
  allPromo: [],

  loading: true,
};

const promoReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case "GET_PROMO":
      return {
        ...state,
        allPromo: action.data,
        loading: action.loading,
      };

    default:
      return state;
  }
};

export default promoReducer;
